!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t():"function"==typeof define&&define.amd?define(t):t()}(this,function(){"use strict";var e=function(e,t,n){switch(t){case"add":e.classList.add(n);break;case"remove":e.classList.remove(n);break;case"toggle":e.classList.toggle(n);break;default:console.log("invalid value for change option specified")}},t=function(t,n,o){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},a=i.change||"add",c=function(t){setTimeout(function(){e(t,a,n)},o)};t.length?[].forEach.call(t,function(e){c(e)}):c(t)};exports.lazy=t});



/*****************
 ** WEBPACK FOOTER
 ** ./~/lazy-class/dist/lazy-class.min.js
 ** module id = 6
 ** module chunks = 0
 **/